import { EditorUtils } from "@progress/kendo-react-editor";

export const insertSpanNode = async (editorRef, innerText, spanId, nameOfClass) => {
  const { view } = editorRef.current.state;
  const schema = view.state.schema;
  // Get the new node from the schema
  const nodeType = schema.nodes.nonEditable;
  // Create a new node with the selected text
  const node = await nodeType.createAndFill({ class: nameOfClass, id: spanId }, schema.text(innerText));
  // Insert the new node
  EditorUtils.insertNode(view, node);
  view.focus();
};

export const replaceSpanNode = async (editorRef, innerText, spanId, nameOfClass, viewPopUps) => {
  if (editorRef.current) {
    const { view } = editorRef.current.state;
    const { state, dispatch } = view;
    const { schema, doc, tr } = state;
    doc.descendants((node, pos) => {
      if (node.type.name === "nonEditable" && node.attrs.id === viewPopUps.tempId) {
        const updatedNode = schema.nodes.nonEditable.create({ class: nameOfClass, id: spanId }, schema.text(innerText));
        const transaction = tr.replaceWith(pos, pos + node.nodeSize, updatedNode);
        dispatch(transaction);
      }
    });
    view.focus();
  }
};
